const votingTypes = Object.freeze({
  UPVOTE: 'upvote',
  DOWNVOTE: 'downvote',
});

export const { UPVOTE, DOWNVOTE } = votingTypes;
